import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";

interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_BAS_REG_033
 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
  .toString()
  .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]); // gridApiRefL 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]);
  const [dataSource2, setDataSource2] = useState<any[]>([]);
  const [gridFocus, setGridFocus] = useState(false);
  const { userInfo } = global();

  interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_PRD_BAS_REG_033";
  const defaultSize = { panel1height: "49.5%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums1(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  useEffect(() => {
    gridApiRefH.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  const onSearch = async () => {
    const modifiedRowsH = gridApiRefH.current.getChange();
    const modifiedRowsL = gridApiRefL.current.getChange();
    const selectedFormData = searchRef.current.getFormdata();
    if (selectedFormData.dt_from > selectedFormData.dt_to) {
      showDialog(
        "alter",
        " 조회기간의 종료일이 시작일보다빠릅니다.확인 후 다시 조회해주시기 바랍니다."
      );
      return;
    }
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
    }
    try {
      const params = {
        id: "sn_prd_bas_reg_033_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource1([]);
      setDataSource2([]);

      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1]);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus(true);
      }

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //#region On Insert
    const onInsert = async () => {
      try {
        const newRow = {}; // 빈 객체
        gridApiRefH.current?.addRow(newRow);
      } catch (error: any) {
      }
    };
  
    //#region On Delete
    const onDelete = async () => {
      const gridApiH = gridApiRefH.current.api;
      const rowCount = gridApiH.getDisplayedRowCount();
      if (rowCount === 0) {
        return;
      }

      const confirm = await showDialog("confirm", "삭제하시겠습니까?");
  
      if (!confirm) {
        return;
      }
  
      gridApiRefL.current?.deleteAllRows();
      gridApiRefH.current?.deleteSelectedRows();
  
      const realDeletedRows = gridApiRefH.current.getChange().delete ?? [];
      if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
        gridApiRefH.current.resetUpdate();
        gridApiRefL.current.resetUpdate();
        return;
      }
      await onSave();
    };

    //#region On AddRow
    const onAddRow = async () => {
      try {
        const newRow = {}; // 빈 객체
        gridApiRefL.current?.addRow(newRow);
        setTimeout(() => {
          gridApiRefL.current.api.setFocusedCell(
            gridApiRefL.current.api.getDisplayedRowCount() - 1,
            "no_seq"
          );
        }, 50);
      } catch (error: any) {}
    };

    //#region On DeleteRow
    const onDeleteRow = async () => {
      const gridApil = gridApiRefL.current.api;
      const rowCount = gridApil.getDisplayedRowCount();
      if (rowCount === 0) {
        return;
      }
  
      gridApiRefL.current?.deleteSelectedRows();
      await gridApiRefL.current.getFooterDataAsync();
    };

  //#region BeforeAddL
  const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      if (!gridApiRefH || gridApiRefH.current.api.getSelectedNodes().length === 0) {
        alert("선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      const gridApiL = gridApiRefL.current.api;
      const rowCount = gridApiL ? gridApiL.getDisplayedRowCount() : 0;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_item: selectedRows[0].data?.cd_item,
        no_line: rowCount + 1,
        no_seq: rowCount + 1,
        dt_start: todayform,
        dt_end: todayform,
        yn_use: "Y",
        nm_checklist: ""
      };

      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false; 
    }
  };

   //#region  OnSave
    const onSave = async () => {
    try {
      let SaveData: any = [0];
      gridApiRefH.current.api.stopEditing();
      gridApiRefL.current.api.stopEditing();

      await new Promise((resolve) => setTimeout(resolve, 0));

      const gridGetChanges = gridApiRefL.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      SaveData["prd_item_checklist"] = gridGetChanges;
      await fnSave("SN_PRD_BAS_REG_033_SAVE_01", SaveData);
      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();

      SaveData = [];
    } catch (error: any) {
   }
  };

  //#region Filter
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      const cd_item = selectedRow.cd_item;
      gridApiRefL.current.applyFilters({ cd_item: cd_item });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
        <SnGrid
          seq={1}
          ref={gridApiRefH}
          
          enableAddRow={true}
          columnConfig={columns1} // 컬럼 설정 전달
          rowData={dataSource1}
          onFocusedRowChanged={onFocusedRowChanged}
          enableExternalChart={false}
          isEditable={true}
          rowSelection="single" // 단일 선택 모드
          resizeController={{
          defaultSize: defaultSize,
          onResizeStop: onResizeStop,
          }}
        />
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
        <SnGrid
          seq={2}
          ref={gridApiRefL}
          
          enableAddRow={true}
          columnConfig={columns2} // 컬럼 설정 전달
          rowData={dataSource2}
          enableExternalChart={false}
          isEditable={true}
          onBtnAddClick={onAddRow}
          onBtnDeleteClick={onDeleteRow}
          onBeforeAddRow={onBeforeAddRowL}
          rowSelection="multiple" // 단일 선택 모드
          title=" "
          resizeController={{
          defaultSize: defaultSize,
          onResizeStop: onResizeStop,
          }}
        />
        </SnResizable>
      </div>
    </div>
  );
});

export default SN_PRD_BAS_REG_033
;
